//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

export const EarnedHeaders = [
  {
    label: "Order Date",
    key: "order_date",
  },

   {
    label: "Post Date",
    key: "post_date",
  },
  {
    label: "Order Number",
    key: "order_number",
  },
  {
    label: "Location Account #",
    key: "customer_account_number",
  },
  {
    label: "Business Name",
    key: "loyalty_organization_name",
  },
  {
    label: "Points Earned",
    key: "points",
  },
  {
    label: "Purchase Amount",
    key: "extended_sales_amount",
  },

  {
    label: "Order ID",
    key: "order_id",
  },


];

export const nonSalesHeaders = [
  {
    label: "Date of Transaction",
    key: "date_of_transaction",
  },
  {
    label: "Transaction Type",
    key: "transaction_type",
  },
  {
    label: "Rule Description",
    key: "rule_description",
  },
  {
    label: "Points Expiration Date",
    key: "points_expiration_date",
  },
  {
    label: "Points Earned",
    key: "points",
  },
  {
    label: "Business Name",
    key: "loyalty_organization_name",
  },
];

export const bonusHeaders = [
  {
    label: "Date of Transaction",
    key: "date_of_transaction",
  },
  {
    label: "Transaction Type",
    key: "transaction_type",
  },
  {
    label: "Rule Description ",
    key: "rule_description",
  },
  {
    label: "Points Expiration Date",
    key: "points_expiration_date",
  },
  {
    label: "Points",
    key: "points",
  },
];

export const RedeemedHeaders = [
  {
    label: "Redemption Date",
    key: "date_of_transaction",
  },
  {
    label: "Status",
    key: "redemption_approval_status",
  },
  {
    label: "Billing Account",
    key: "customer_billto_account_number",
  },
  {
    label: "Shipto ID",
    key: "customer_account_number",
  },
  {
    label: "Rejected Reason",
    key: "rejected_reason",
  },
  {
    label: "Business Name",
    key: "loyalty_organization_name",
  },
  {
    label: "Points Redeemed",
    key: "points_redeemed",
  },
  {
    label: "Credit Issued",
    key: "credit_issued",
  },
];

export const PendingHeaders = [
  {
    label: "Date of Transaction",
    key: "date_of_transaction",
  },
  {
    label: "Order Date",
    key: "order_number",
  },
  {
    label: "Shipped Date",
    key: "post_date",
  },
  {
    label: "Order Number",
    key: "order_id",
  },
  {
    label: "Customer Account Number",
    key: "customer_account_number",
  },
  {
    label: "Product Description",
    key: "product_short_description",
  },
  {
    label: "Sales Category",
    key: "loyalty_category_code",
  },
  {
    label: "Expiring Date",
    key: "expiry_month",
  },
];

export const EarnedPendingHeaders = [
  {
    label: "Order Date",
    key: "order_date",
  },
  {
    label: "Order Number",
    key: "order_number",
  },
  {
    label: "Location Account #",
    key: "customer_account_number",
  },
  {
    label: "Points",
    key: "points",
  },
  {
    label: "Business Name",
    key: "loyalty_organization_name",
  },
];

export const RedeemedPendingHeaders = [
  {
    label: "Redemption Date",
    key: "date_of_transaction",
  },
  {
    label: "Status",
    key: "redemption_approval_status",
  },
  {
    label: "Bill to",
    key: "customer_billto_account_number",
  },

  {
    label: "Shipto ID",
    key: "customer_account_number",
  },
  {
    label: "Reason",
    key: "reason_code",
  },
  {
    label: "Business Name",
    key: "loyalty_organization_name",
  },
  {
    label: "Points Redeemed",
    key: "points_redeemed",
  },
  {
    label: "Credit Issued",
    key: "credit_issued",
  },
];
